let hubble = null;

class Hubble {
  init() {
    if (window.DATracker) {
      hubble = window.DATracker;
      window.DATracker.init('MA-B69F-267A4364378E', {
        use_app_track: true,
      });
    }
    return this;
  }

  trace(eventId, content) {
    hubble && hubble.track(eventId, content);
    return this;
  }
}

const h = new Hubble();

export default h;
